export default __webpack_public_path__ + "static/media/home-hero2.50a48f6c.jpg";